module.exports = __webpack_public_path__ + "static/media/climate_water_1_politicalBordersWatersheds_700px.fea98bfb.jpg";